'use client'

import React from 'react'
import Image from 'next/image'
import { useTranslations } from 'next-intl'
import { useMediaQuery } from '@segway/core'

// import { useState } from 'react'
import { Arrow } from '@/components/icons'
import { Button, Input } from '@/ui'

import { useSubscribe } from '../../../../hooks/footer'
import { SubscribeType } from '../types'

interface SubscribeProps {
  blockData: SubscribeType
}

const Subscribe = ({ blockData }: SubscribeProps) => {
  const responsive = useMediaQuery()
  const tCommon = useTranslations('Common')

  const { handleSubmit, isLoading, register, onSubmit } = useSubscribe('pageend_signup')

  return (
    <div className="w-full px-7 max-xl:px-4">
      <div className="relative mx-auto flex min-h-[340px] flex-col overflow-hidden rounded-[20px] bg-[#F3F3F4] p-[48px] max-xl:min-h-[322px] max-xl:rounded-lg max-xl:p-[24px] max-xl:pb-[32px] 2xl:max-w-[1440px]">
        <Image
          src={responsive && responsive.xl ? blockData?.pc_image : blockData?.mob_image}
          alt={blockData?.title}
          fill
          style={{ objectFit: 'cover' }}
        />
        <div className="relative w-[709px] max-xl:w-full max-xl:text-center">
          <div className="font-miSansDemiBold450 text-[40px] leading-[52px] max-xl:text-[18px] max-xl:leading-[25px]">
            {blockData?.title}
          </div>
          <div className="mt-[10px] text-[14px] leading-[20px] max-xl:text-[12px] max-xl:leading-[16px] max-xl:text-[#6E6E73] xl:mt-[12px]">
            {blockData?.subtitle}
          </div>
        </div>
        <form
          className="relative mt-[60px] flex w-[482px] max-xl:mt-[124px] max-xl:w-full"
          onSubmit={handleSubmit((data) => {
            onSubmit(data)
          })}>
          <div className="flex-1">
            <Input
              {...register('email')}
              autoComplete="off"
              className="h-[48px] rounded-bl-[8px] rounded-br-[0px] rounded-tl-[8px] rounded-tr-[0px] border-[#aaaaab] border-transparent bg-white px-[12px] placeholder:text-[#999]"
              placeholder={tCommon('your_email')}
            />
          </div>
          <Button
            variant="default"
            type="submit"
            disabled={isLoading}
            className="h-[48px] w-[48px] rounded-l-[0px] rounded-r-[8px] bg-[#000000] hover:bg-[#0F0F0F] active:bg-[#000000] disabled:bg-[#BBBBBD]">
            <Arrow width={24} height={24} color="#ffffff" />
          </Button>
        </form>
        {/* {showTerms && (
          <div className="flex w-[800px] items-center">
            {buttonClickCount === 1 ? (
              <>
                <input type="checkbox" />
                <span className="ml-[10px] text-[14px]">
                  I have read and accept the [
                  <a href="#" className="text-[#f33333] underline">
                    Terms of Service Name
                  </a>
                  ] and [
                  <a href="#" className="text-[#f33333] underline">
                    Terms of Service Name
                  </a>{' '}
                  ] by checking this box
                </span>
              </>
            ) : (
              <div className="flex items-center justify-center gap-[8px] text-[14px] text-[#f33333]">
                <Annotate /> Your subscription has been successful
              </div>
            )}
          </div>
        )} */}
      </div>
    </div>
  )
}

export default Subscribe
